import { useEffect, useState } from "react";
//--------------------------------------------------------------------------------------------
import { useMyStore } from "src/components/main/mainStore";
import { myAxios } from "src/components/common/functions";
import WorkLogForm from "../workLogForm"
//--------------------------------------------------------------------------------------------
export default function WeeklyMaintenanceZerkFittings({
    ...rest
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const [truckNumbers, setTruckNumbers] = useState([]);
    useEffect(() => {
        let isMounted = true;
        const getData = async() => {
            //---------------------------------------------------
            setShowLoader(true);
            const res = await myAxios("common/readTruckNumbers.php");
            if(!isMounted) return;
            setShowLoader(false);
            if(!res) return;
            //---------------------------------------------------
            setTruckNumbers(res.data.map(d => d.truckNumber));
        }
        getData();
        return () => {
            isMounted = false;
        }
    }, [])
    //--------------------------------------------------------------------------------------------
    const items = [
        {title: "Driver", type: "text", required: true, default: user.userName}, 
        {title: "Truck Number", type: "select", required: true, options: truckNumbers}, 
        {title: "Date", type: "date", required: true}, 
        {title: "Location", type: "text", required: true}, 
        {title: "Battery powered or electric grease gun 10,000 psi used.", type: "radio", required: true}, 
        {title: "Approver Notes"}
    ];
    const Pre = <div className = "my-2 text-secondary font-weight-bold font-italic">
        <p>
            PPE required harness & restraint tied off on vehicle.
        </p>
    </div>;
    //--------------------------------------------------------------------------------------------
    return(
        <WorkLogForm
            sendEmail
            correctiveActionNeed = {true}
            prefix = {Pre}
            picsLimit = {0}
            items = {items}
            {...rest}
        />
    )    
}